import { render } from "./welcomePaper.vue?vue&type=template&id=314d6ab4&scoped=true"
import script from "./welcomePaper.vue?vue&type=script&lang=js"
export * from "./welcomePaper.vue?vue&type=script&lang=js"

import "./welcomePaper.vue?vue&type=style&index=0&id=314d6ab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314d6ab4"]])

export default __exports__